/**
 * Enum of languages circle "speak" in the game.
 */
export enum Languages {
  ENGLISH = 'english',
  SPANISH = 'spanish',
  FRENCH = 'french',
  GERMAN = 'german',
  CHINESE = 'chinese',
  JAPANESE = 'japanese',
}

/**
 * Map of locale codes to their language values.
 *
 * Only use this where required, stick with the enum values where possible
 *
 */
export const LanguageCodes = {
  en: 'english',
  es: 'spanish',
  fr: 'french',
  de: 'german',
  zh: 'chinese',
  ja: 'japanese',
} as const satisfies Record<string, string>;

// Extract the union of language string values from the map above
export type Language = (typeof LanguageCodes)[keyof typeof LanguageCodes];
// Locale code union
export type LanguageCode = keyof typeof LanguageCodes;

// NOTE: Language type now derived from LanguageCodes above.

/**
 * List of all languages
 */
export const LANGUAGES = Object.values(Languages);

/**
 * Helper function that returns all languages except the excluded one.
 *
 * @param excludedLanguage the language to exclude
 * @returns an array of all languages except the excluded one
 */
export function getAllLanguagesButOne(excludedLanguage: Languages): Languages[] {
  return LANGUAGES.filter((lang) => lang !== excludedLanguage);
}

/**
 * Helper function that returns a random language from the given array.
 *
 * @param languages the languages to return a random one for
 */
export function getRandomLanguage(languages: Languages[]) {
  const randomIndex = Math.floor(Math.random() * languages.length);
  return languages[randomIndex];
}
